import React, { useState } from 'react';
import { CssBaseline, Grid } from '@mui/material';
import SuperAdminSideNav from 'components/sideNav/SuperAdminSideNav';
import { drawerWidthEnum } from 'utils/enumObj';
import { useStyles } from './LayoutStyle';

// Multi-tenancy platform console layout (super admin, role 99).
//
// A sibling of the tenant Layout that reuses the same sidebar chrome/styles so
// the console looks identical — but it deliberately OMITS the tenant Header
// and ActingAsBanner. Those fire tenant-module APIs (getProfile,
// fetchRolesAndPermissions, notifications) that 403 a role-99 session and eject
// it via the response interceptor — which is exactly why the old superadmin
// routes used layout: null (and had no logout). This layout gives the super
// admin the side-nav (hence Logout + navigation) without that hazard.
const SuperAdminLayout = ({ children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(drawerWidthEnum.maxWidth);
  const [onlyMobile, setOnlyMobile] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
    setDrawerWidth(open ? drawerWidthEnum.maxWidth : drawerWidthEnum.minWidth);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setDrawerWidth(drawerWidthEnum.minWidth);
  };

  const handelOnMobile = () => {
    setOnlyMobile(!onlyMobile);
    setDrawerWidth(drawerWidthEnum.maxWidth);
  };

  return (
    <Grid className={classes.root}>
      <CssBaseline />
      <Grid container item className={classes.mainBody}>
        <SuperAdminSideNav
          open={open}
          onlyMobile={onlyMobile}
          onMobileOpen={handelOnMobile}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
        />
        <Grid
          item
          className={`${classes.content} formDiv`}
          sx={{
            flexGrow: 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            // No fixed header here, so reclaim the header gutter the tenant
            // content class reserves (marginTop: 115px).
            mt: { xs: '24px', sm: '32px' },
          }}
        >
          <div className="layoutChildren">{children}</div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SuperAdminLayout;
